<template>
  <div>
    <div style="display: inline-flex; align-items: center;">
      <label>
        zusätzliche freie Spende:
      </label>
      <md-field :class="{ 'md-error': resolveFailed, 'md-valid': resolvePassed }" style="margin-left: 8px; flex: 0 1 60px; width: 60px;">
        <md-input @input="debouncedUpdateValue($event)"></md-input>

        <slide-y-down-transition>
          <md-icon class="error" v-show="resolveFailed">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon class="success" v-show="resolvePassed">done</md-icon>
        </slide-y-down-transition>
      </md-field>

      <div v-if="resolveFailed" class="text-danger" style="margin-left: 18px">
        Bitte gib einen gültigen Betrag ein.
      </div>
    </div>

    <dynamic-form
      ref="donationOptions"
      v-if="donationForm && numberValue > 0"
      :formFields="donationForm"
      style="max-width: 600px"
      :hideSubmit="true"
    />
  </div>
</template>

<script>
import DynamicForm from '@/components/DynamicForm/DynamicForm';
import debounce from '@/utils/debounce';

export default {
  props: ['donationForm'],
  components: {
    DynamicForm
  },
  data() {
    return {
      value: undefined,
      debouncedUpdateValue: debounce((value) => {
        this.value = value;
        // console.log("emit", this.value, this.numberValue)
        this.$emit('input', this.numberValue);
      })
    }
  },
  computed: {
    numberValue() {
      // match nothing or point or space as thousand separator and comma as decimal separator with
      // up to two decimal places and possibly trailing zeros
      if (this.hasValue && this.value.match(/^\s*(\d+|(\d{1,3}((\.\d{3})*|( \d{3})*)))(,\d{0,2}0*)?\s*$/)) {
        return Number(this.value.replace(/[\s\.]/g, '').replace(',', '.'));
      }
      return undefined;
    },
    hasValue() {
      return this.value && this.value.trim();
    },
    resolveFailed() {
      return this.hasValue && this.numberValue === undefined;
    },
    resolvePassed() {
      return this.hasValue && this.numberValue !== undefined;
    },
  },
  methods: {
    validate() {
      return !this.$refs.donationOptions || this.$refs.donationOptions.validate();
    },
    getDonationFormData() {
      return this.$refs.donationOptions && this.$refs.donationOptions.formData;
    }
  }
};
</script>

<style lang="css" scoped>
</style>
